import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';
import { GenericViewConfig } from './dashboard.template.model';
import { DashboardType, ViewType } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

@modelOptions({ schemaOptions: { _id: false } })
class ActiveViewProps {
  @prop({ required: true })
  id: string;

  @prop({ required: true, type: Number, enum: ViewType })
  type: ViewType;
}

@modelOptions({ schemaOptions: { _id: false } })
class SmartViewsPanelConfig {
  @prop({ required: true })
  isOpen: boolean;
}

@modelOptions({ schemaOptions: { _id: false } })
class ViewCategoryState {
  @prop({ required: true })
  id: string;

  @prop({ required: true })
  isOpen: boolean;
}

@modelOptions({ schemaOptions: { _id: false } })
class WidgetCategoryState {
  @prop({ required: true })
  id: string;

  @prop({ required: true })
  isOpen: boolean;
}

@modelOptions({ schemaOptions: { _id: false } })
class PopUpConfiguration {
  @prop({ required: true })
  shouldDisplayDiscard: boolean;

  @prop({ required: true })
  shouldDisplayUnsavedChanges: boolean;
}

@modelOptions({ schemaOptions: { _id: false } })
class UserDashboardUiConfig {
  @prop({ required: true })
  smartViewsPanel: SmartViewsPanelConfig;

  @prop({ required: true, type: [WidgetCategoryState] })
  widgetsCategoriesState: Array<WidgetCategoryState>;

  @prop({ required: true, type: [ViewCategoryState] })
  smartViewsCategoriesState: Array<ViewCategoryState>;

  @prop({ required: true })
  popUp: PopUpConfiguration;
}

@modelOptions({
  schemaOptions: { collection: 'userDashboards', versionKey: false },
  options: { customName: 'userDashboards' },
})
export class UserDashboardConfig {
  @prop({ required: true })
  userId: mongoose.Types.ObjectId;

  @prop({ required: true, type: Number, enum: DashboardType })
  dashboardType: DashboardType;

  @prop({ required: true })
  activeViewProps: ActiveViewProps;

  @prop({ required: true })
  uiConfig: UserDashboardUiConfig;

  @prop({ required: true, type: GenericViewConfig })
  smartViews: Array<GenericViewConfig>;
}
